import axios from '@/utils/request/index.js'

const list = async (body) => {
  try {
    const { data } = await axios.post('/share/getMyCustomerNoticeCardList', {
      ...body,
    })
    return data.data
  } catch (error) {

    throw error
  }
}

const details = async (body) => {
  try {
    const { data } = await axios.post('/share/getCustomerNotice', {
      ...body,
    })
    return data.data
  } catch (error) {

    throw error
  }
}


export default {
  list,
  details,
}